import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';

import BucketsGridLayout from './containers/Grid';

export default function BucketLayout() {
  return <Router>
    <PrivateRoute path="/offer/allocations/:id/buckets" component={BucketsGridLayout} />
  </Router>
}

